import { LocationDetail } from "@/types/location";

import { requestData } from "@/api/api-config";

async function getLocations(
  includeArchived: boolean = false,
): Promise<LocationDetail[] | null> {
  return await requestData<LocationDetail[]>(
    "check-in/calendar/locations",
    "get",
    {
      cache: "default",
      searchParams: includeArchived ? { include_archived: true } : undefined,
    },
    false,
  );
}

export const calendarQueryKeys = {
  all: ["calendar"] as const,
  // Prefix shared by every locations variant. Invalidate this to refresh the
  // location list (both includeArchived variants) without touching event queries.
  locationsRoot: ["calendar", "locations"] as const,
  locations: (includeArchived: boolean = false) =>
    [...calendarQueryKeys.all, "locations", { includeArchived }] as const,
};

export const calendarQueryOptions = {
  locations: (includeArchived: boolean = false) => ({
    queryKey: calendarQueryKeys.locations(includeArchived),
    queryFn: () => getLocations(includeArchived),
    select: (data: LocationDetail[] | null): LocationDetail[] => data ?? [],
  }),
};
